const DEFAULT_FRAMING = Object.freeze({
  x: 50,
  y: 35,
  scale: 1,
});

const clampPercent = (value, fallback) => {
  const number = Number(value);
  if (!Number.isFinite(number)) return fallback;
  return Math.min(100, Math.max(0, number));
};

const normalizeFraming = (framing = {}) => ({
  x: clampPercent(framing.x, DEFAULT_FRAMING.x),
  y: clampPercent(framing.y, DEFAULT_FRAMING.y),
  scale: Math.min(2, Math.max(1, Number.isFinite(Number(framing.scale)) ? Number(framing.scale) : DEFAULT_FRAMING.scale)),
});

/**
 * Exercise image references remain strings in the existing catalog. New records
 * may use { path, focal_point: { x, y }, scale } without requiring a migration.
 */
export const normalizeExerciseImage = (image, exercise = null) => {
  const reference = typeof image === 'string' ? { path: image } : (image || {});
  const path = typeof reference.path === 'string' ? reference.path.trim() : '';
  const mapped = exercise?.image_focal_points?.[path] || {};
  const focalPoint = reference.focal_point || reference.focalPoint || mapped;

  return {
    path,
    framing: normalizeFraming({
      ...mapped,
      ...reference,
      ...(focalPoint || {}),
    }),
  };
};

export const getExerciseImageStyle = (image, exercise = null) => {
  const { path, framing } = normalizeExerciseImage(image, exercise);
  return {
    path,
    style: {
      backgroundSize: framing.scale > 1 ? `${Math.round(framing.scale * 100)}%` : 'cover',
      backgroundPosition: `${framing.x}% ${framing.y}%`,
    },
  };
};

export { DEFAULT_FRAMING };
